import React from "react";
import { Row } from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";
import { Text } from "./text";

interface BackButtonProps {
  onPress?: () => void;
  testID?: string;
}

export function BackButton(props: BackButtonProps) {
  const { onPress } = props;
  const { fbt, locale } = useI18n();
  return (
    <button
      className="back-button"
      onClick={(e) => {
        e.preventDefault();
        if (onPress) {
          onPress();
        }
      }}
    >
      <Row alignItems="center">
        <Text color="link">
          {locale.direction === "ltr" ? "← " : "→ "}
          {fbt("Back")}
        </Text>
      </Row>
    </button>
  );
}
